import { Checkbox } from "./checkbox";
import { cr } from "fire-wind-water";

class CheckboxSelect extends Checkbox {
  constructor(filed: unknown) {
    super(filed);
  }

  setValue(o: any[]): void {
    this.value = [];
    this.label = [];
    this.model = [];
    this.otherValue = [];
    cr.each(this.listOptions, (d) => {
      d.disabled = false;
      d.checked = o.indexOf(d.optionId) !== -1;
      if (d.checked) {
        if (
          this.selectOptionLimit > 0 &&
          this.value.length >= this.selectOptionLimit
        ) {
          d.checked = false;
          return;
        }
        this.value.push(d.optionValue);
        this.label.push(d.optionId);
        this.model.push(d);
        if (d.otherisFillIn == 1) {
          this.otherValue.push({ [d.optionValue]: d.otherValue });
        }
      }
    });
    if (
      this.selectOptionLimit > 0 &&
      this.value.length >= this.selectOptionLimit
    ) {
      cr.each(this.listOptions, (d) => {
        if (!d.checked) {
          d.disabled = true;
        }
      });
    }
    this.dirty = true;
    this.isError();
  }
}

export { CheckboxSelect };
